import { render, staticRenderFns } from "./tabEditBoatLicense.vue?vue&type=template&id=95684e78&"
import script from "./tabEditBoatLicense.vue?vue&type=script&lang=js&"
export * from "./tabEditBoatLicense.vue?vue&type=script&lang=js&"
import style0 from "./tabEditBoatLicense.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports